
import ViewBase from "../../view-base.view";

export default function FixtureUploadResult() {
  ViewBase.call(this);

  let onClose = (e) => { };
  let results = [];

  return {
    oninit: (vnode) => {
      if (vnode.attrs.uploadedResult) {
        results = vnode.attrs.uploadedResult
      }
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }

    },
    view: (vnode) => {
      return [
        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12',
                m('.table-responsive',
                  m('table.table.table-sm',
                    m('thead',
                      m('tr.align-middle.center',
                        m('th', this.getText('LT00001197', 'Image Name')),
                        m('th', this.getText('LT00000015', 'Status')),
                        m('th', this.getText('LT00000152', 'Remarks'))
                      )
                    ),
                    m('tbody',
                      results?.length === 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "100%" },
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      results?.length > 0 &&
                      results.map((data,) => {
                        const active = data.status === "Success";
                        return m('tr.align-middle.center',
                          m('td', m('span.cursor-text', data.filename)),
                          m('td', m(`span.badge.rounded-pill${active ? '.green-bg-status' : '.danger-bg-status'}`, active ? this.getText('EM00000004', 'Success') : this.getText('EM00000036', 'Fail'))),
                          m('td', m('span.cursor-text', data.remark))
                        )
                      }))
                  )
                )
              )
            ),
                      
          )
        ),
        m('.col-md-12.gap-2.mt-4.d-flex.justify-content-end',
          m(
            "button.btn.btn-white[type='button']", { onclick: onClose },
            this.getText("LT00000021", "Close")
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
